import { Initializer } from './main/initializer.js'

// eslint-disable-next-line no-new
new Initializer()
